export default __webpack_public_path__ + "static/media/category_hoodie.c160a8d5.webp";